// import React, { useState, useEffect, useRef } from "react";
// import { createPortal } from "react-dom";
// import axios from "axios";
// import {
//   RiShoppingBag2Line,
//   RiAddLine,
//   RiSearchLine,
//   RiCloseLine,
//   RiEditLine,
//   RiDeleteBinLine,
//   RiCheckLine,
//   RiErrorWarningLine,
//   RiRefreshLine,
//   RiFileTextLine,
//   RiGiftLine,
//   RiStackLine,
//   RiOctagonLine,
//   RiAddCircleLine,
//   RiBarcodeLine, // Added for HSN Code
// } from "react-icons/ri";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";

// const BASE_URL = `${process.env.REACT_APP_API_URL}/product`;
// const CATEGORY_URL = `${process.env.REACT_APP_API_URL}/category`;

// const defaultForm = {
//   name: "",
//   description: "",
//   categoryId: "",
//   hsnCode: "", // Added hsnCode
//   variations: [],
// };

// const defaultVariation = {
//   size: "",
//   price: "",
//   quantity: "",
// };

// const Spinner = () => (
//   <AiOutlineLoading3Quarters className="animate-spin w-4 h-4" />
// );

// const Toast = ({ message, type, onClose }) => {
//   useEffect(() => {
//     const t = setTimeout(onClose, 3500);
//     return () => clearTimeout(t);
//   }, []);
//   return (
//     <div
//       className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
//       ${
//         type === "success"
//           ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
//           : "bg-red-50 border border-red-200 text-red-800"
//       }`}
//     >
//       {type === "success" ? (
//         <RiCheckLine className="w-4 h-4 text-emerald-500" />
//       ) : (
//         <RiErrorWarningLine className="w-4 h-4 text-red-500" />
//       )}
//       <span>{message}</span>
//       <button
//         onClick={onClose}
//         className="ml-2 opacity-50 hover:opacity-100 transition"
//       >
//         <RiCloseLine className="w-4 h-4" />
//       </button>
//     </div>
//   );
// };

// const Modal = ({ title, onClose, children, size = "md" }) =>
//   createPortal(
//     <div className="fixed inset-0 z-40 flex items-center justify-center">
//       <div
//         className="absolute inset-0 bg-blue-950/40 backdrop-blur-sm"
//         onClick={onClose}
//       />
//       <div
//         className={`relative z-10 w-full ${
//           size === "lg" ? "max-w-4xl" : size === "sm" ? "max-w-sm" : "max-w-2xl"
//         } mx-4 bg-white border border-blue-100 rounded-2xl shadow-2xl overflow-hidden`}
//       >
//         <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-blue-50">
//           <h2 className="text-base font-semibold text-blue-900 flex items-center gap-2">
//             {title}
//           </h2>
//           <button
//             onClick={onClose}
//             className="text-blue-400 hover:text-blue-700 transition rounded-lg p-1 hover:bg-blue-100"
//           >
//             <RiCloseLine className="w-5 h-5" />
//           </button>
//         </div>
//         <div className="p-6 max-h-[80vh] overflow-y-auto bg-white">
//           {children}
//         </div>
//       </div>
//     </div>,
//     document.body,
//   );

// const fieldIconMap = {
//   name: RiOctagonLine,
//   description: RiFileTextLine,
//   categoryId: RiStackLine,
//   hsnCode: RiBarcodeLine, // Added icon for HSN Code
// };

// const Field = ({
//   label,
//   name,
//   value,
//   onChange,
//   type = "text",
//   placeholder,
//   as = "input",
//   options = [],
// }) => {
//   const Icon = fieldIconMap[name] || RiFileTextLine;
//   return (
//     <div className="flex flex-col gap-1.5">
//       <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//         {label}
//       </label>
//       <div className="relative">
//         <Icon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
//         {as === "textarea" ? (
//           <textarea
//             name={name}
//             value={value}
//             onChange={onChange}
//             placeholder={placeholder || label}
//             rows={3}
//             className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition resize-none"
//           />
//         ) : as === "select" ? (
//           <select
//             name={name}
//             value={value}
//             onChange={onChange}
//             className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none cursor-pointer"
//           >
//             <option value="">Select {label}</option>
//             {options.map((opt) => (
//               <option key={opt._id || opt} value={opt._id || opt}>
//                 {opt.name || opt}
//               </option>
//             ))}
//           </select>
//         ) : (
//           <input
//             type={type}
//             name={name}
//             value={value}
//             onChange={onChange}
//             placeholder={placeholder || label}
//             className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// const VariationField = ({ variation, onChange, onRemove, index }) => {
//   return (
//     <div className="bg-blue-50/30 border border-blue-100 rounded-lg p-4 mb-3">
//       <div className="flex items-center justify-between mb-3">
//         <h4 className="text-sm font-semibold text-slate-700">
//           Variation {index + 1}
//         </h4>
//         {onRemove && (
//           <button
//             type="button"
//             onClick={onRemove}
//             className="text-red-500 hover:text-red-700 transition"
//           >
//             <RiDeleteBinLine className="w-4 h-4" />
//           </button>
//         )}
//       </div>
//       <div className="grid grid-cols-3 gap-3">
//         <input
//           type="text"
//           placeholder="Size (S, M, L, XL)"
//           value={variation.size || ""}
//           onChange={(e) => onChange({ ...variation, size: e.target.value })}
//           className="bg-white border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//         />
//         <input
//           type="number"
//           placeholder="Price"
//           value={variation.price || ""}
//           onChange={(e) =>
//             onChange({ ...variation, price: parseFloat(e.target.value) || "" })
//           }
//           className="bg-white border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//         />
//         <input
//           type="number"
//           placeholder="Quantity"
//           value={variation.quantity || ""}
//           onChange={(e) =>
//             onChange({ ...variation, quantity: parseInt(e.target.value) || "" })
//           }
//           className="bg-white border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//         />
//       </div>
//     </div>
//   );
// };

// const FormBody = ({
//   form,
//   handleChange,
//   handleVariationChange,
//   handleAddVariation,
//   handleRemoveVariation,
//   categories,
// }) => (
//   <>
//     <div className="grid grid-cols-2 gap-4 mb-4">
//       <Field
//         label="Product Name"
//         name="name"
//         value={form.name}
//         onChange={handleChange}
//       />
//       <Field
//         label="Category"
//         name="categoryId"
//         value={form.categoryId}
//         onChange={handleChange}
//         as="select"
//         options={categories}
//       />
//     </div>

//     <div className="grid grid-cols-2 gap-4 mb-4">
//       <Field
//         label="HSN Code"
//         name="hsnCode"
//         value={form.hsnCode}
//         onChange={handleChange}
//         placeholder="e.g., 84716000"
//       />
//     </div>

//     <div className="mb-4">
//       <Field
//         label="Description"
//         name="description"
//         value={form.description}
//         onChange={handleChange}
//         as="textarea"
//       />
//     </div>

//     <div className="mb-6">
//       <div className="flex items-center justify-between mb-3">
//         <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//           Variations
//         </label>
//         <button
//           type="button"
//           onClick={handleAddVariation}
//           className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
//         >
//           <RiAddLine className="w-3.5 h-3.5" /> Add Variation
//         </button>
//       </div>

//       {form.variations && form.variations.length > 0 ? (
//         form.variations.map((variation, idx) => (
//           <VariationField
//             key={idx}
//             index={idx}
//             variation={variation}
//             onChange={(v) => handleVariationChange(idx, v)}
//             onRemove={() => handleRemoveVariation(idx)}
//           />
//         ))
//       ) : (
//         <div className="text-center py-8 bg-blue-50/30 border border-dashed border-blue-200 rounded-lg">
//           <RiGiftLine className="w-8 h-8 text-blue-300 mx-auto mb-2" />
//           <p className="text-sm text-slate-400">
//             No variations added. Click "Add Variation" to get started.
//           </p>
//         </div>
//       )}
//     </div>
//   </>
// );

// const tableHeaders = [
//   { label: "Product Name", Icon: RiOctagonLine },
//   { label: "HSN Code", Icon: RiBarcodeLine }, // Added HSN Code column
//   { label: "Category", Icon: RiStackLine },
//   { label: "Description", Icon: RiFileTextLine },
//   { label: "Variations (Size | Price | Qty)", Icon: RiGiftLine },
//   { label: "Actions" },
// ];

// export default function Products() {
//   const [products, setProducts] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [modal, setModal] = useState(null);
//   const [selected, setSelected] = useState(null);
//   const [form, setForm] = useState(defaultForm);
//   const [toast, setToast] = useState(null);
//   const [search, setSearch] = useState("");

//   // Stock modal state
//   const [stockModal, setStockModal] = useState(null); // { product, variation }
//   const [stockQty, setStockQty] = useState("");
//   const [stockLoading, setStockLoading] = useState(false);

//   const notify = (message, type = "success") => setToast({ message, type });

//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(`${CATEGORY_URL}/all`);
//       setCategories(res.data?.categories || res.data?.data || res.data || []);
//     } catch (error) {
//       console.error("Failed to fetch categories:", error);
//     }
//   };

//   const fetchProducts = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${BASE_URL}/all`);
//       setProducts(res.data?.products || res.data?.data || res.data || []);
//     } catch {
//       notify("Failed to fetch products", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProducts();
//     fetchCategories();
//   }, []);

//   const openCreate = () => {
//     setForm({ ...defaultForm, variations: [{ ...defaultVariation }] });
//     setModal("create");
//   };

//   const openEdit = (product) => {
//     setSelected(product);
//     setForm({
//       name: product.name || "",
//       description: product.description || "",
//       categoryId: product.categoryId?._id || product.categoryId || "",
//       hsnCode: product.hsnCode || "", // Added hsnCode
//       variations: product.variations || [{ ...defaultVariation }],
//     });
//     setModal("edit");
//   };

//   const openDelete = (product) => {
//     setSelected(product);
//     setModal("delete");
//   };

//   const closeModal = () => {
//     setModal(null);
//     setSelected(null);
//   };

//   // Open the small stock-add modal
//   const openStockModal = (product, variation) => {
//     setStockModal({ product, variation });
//     setStockQty("");
//   };

//   const closeStockModal = () => {
//     setStockModal(null);
//     setStockQty("");
//   };

//   const handleAddStock = async () => {
//     const addQty = parseInt(stockQty);
//     if (!addQty || addQty <= 0) {
//       notify("Please enter a valid quantity", "error");
//       return;
//     }

//     setStockLoading(true);
//     try {
//       const newQty = (stockModal.variation.quantity || 0) + addQty;
//       await axios.patch(`${BASE_URL}/update-stock`, {
//         productId: stockModal.product._id,
//         size: stockModal.variation.size,
//         quantity: newQty,
//       });
//       notify(
//         `Added ${addQty} units to ${stockModal.product.name} (${stockModal.variation.size})`,
//       );
//       fetchProducts();
//       closeStockModal();
//     } catch (error) {
//       notify("Failed to update stock", "error");
//       console.error("Stock update error:", error);
//     } finally {
//       setStockLoading(false);
//     }
//   };

//   const handleChange = (e) =>
//     setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

//   const handleVariationChange = (index, variation) => {
//     setForm((f) => {
//       const newVariations = [...f.variations];
//       newVariations[index] = variation;
//       return { ...f, variations: newVariations };
//     });
//   };

//   const handleAddVariation = () => {
//     setForm((f) => ({
//       ...f,
//       variations: [...f.variations, { ...defaultVariation }],
//     }));
//   };

//   const handleRemoveVariation = (index) => {
//     setForm((f) => ({
//       ...f,
//       variations: f.variations.filter((_, i) => i !== index),
//     }));
//   };

//   const handleCreate = async () => {
//     if (!form.name.trim() || !form.categoryId || form.variations.length === 0) {
//       notify("Please fill all required fields", "error");
//       return;
//     }

//     // Optional: Validate HSN code format
//     if (form.hsnCode && !/^\d{4,8}$/.test(form.hsnCode)) {
//       notify("HSN code must be 4 to 8 digits", "error");
//       return;
//     }

//     setActionLoading(true);
//     try {
//       await axios.post(`${BASE_URL}/create`, form);
//       notify("Product created successfully");
//       fetchProducts();
//       closeModal();
//     } catch (error) {
//       notify("Failed to create product", "error");
//       console.error("Create error:", error);
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleUpdate = async () => {
//     if (!form.name.trim() || !form.categoryId || form.variations.length === 0) {
//       notify("Please fill all required fields", "error");
//       return;
//     }

//     // Optional: Validate HSN code format
//     if (form.hsnCode && !/^\d{4,8}$/.test(form.hsnCode)) {
//       notify("HSN code must be 4 to 8 digits", "error");
//       return;
//     }

//     setActionLoading(true);
//     try {
//       await axios.put(`${BASE_URL}/update/${selected._id}`, form);
//       notify("Product updated successfully");
//       fetchProducts();
//       closeModal();
//     } catch (error) {
//       notify("Failed to update product", "error");
//       console.error("Update error:", error);
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleDelete = async () => {
//     setActionLoading(true);
//     try {
//       await axios.delete(`${BASE_URL}/delete/${selected._id}`);
//       notify("Product deleted successfully");
//       fetchProducts();
//       closeModal();
//     } catch (error) {
//       notify("Failed to delete product", "error");
//       console.error("Delete error:", error);
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const filtered = products.filter(
//     (p) =>
//       (p.name || "").toLowerCase().includes(search.toLowerCase()) ||
//       (p.description || "").toLowerCase().includes(search.toLowerCase()) ||
//       (p.hsnCode || "").toLowerCase().includes(search.toLowerCase()), // Added HSN code search
//   );

//   return (
//     <div className="min-h-screen bg-white text-slate-800">
//       <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
//         <div className="w-full mx-auto px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
//           <div className="flex items-center gap-3">
//             <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-md shadow-blue-200">
//               <RiShoppingBag2Line className="w-5 h-5" />
//             </div>
//             <div>
//               <h1 className="text-base font-bold text-blue-800 tracking-tight">
//                 Products
//               </h1>
//               <p className="text-[11px] text-blue-400 tracking-widest uppercase">
//                 Product Management
//               </p>
//             </div>
//           </div>

//           <div className="flex items-center gap-3">
//             <div className="relative">
//               <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400" />
//               <input
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 placeholder="Search products..."
//                 className="bg-blue-50 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-700 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 w-52 transition"
//               />
//             </div>

//             <button
//               onClick={fetchProducts}
//               disabled={loading}
//               title="Refresh"
//               className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-600 hover:bg-blue-50 transition disabled:opacity-50"
//             >
//               <RiRefreshLine
//                 className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
//               />
//             </button>

//             <button
//               onClick={openCreate}
//               className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm px-4 py-2 rounded-lg transition-all shadow-md shadow-blue-200"
//             >
//               <RiAddLine className="w-4 h-4" />
//               Add Product
//             </button>
//           </div>
//         </div>
//       </header>

//       <div className="w-full mx-auto px-6 pt-6 pb-10">
//         <div className="bg-white border border-blue-100 rounded-2xl overflow-hidden shadow-sm">
//           <div className="px-5 py-3.5 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
//             <span className="text-sm font-semibold text-blue-800 flex items-center gap-2">
//               <RiShoppingBag2Line className="w-4 h-4 text-blue-500" />
//               All Products
//             </span>
//             <span className="text-xs text-blue-400">
//               {filtered.length} record{filtered.length !== 1 ? "s" : ""}
//             </span>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead>
//                 <tr className="border-b border-blue-100 bg-blue-50/30">
//                   {tableHeaders.map(({ label, Icon }) => (
//                     <th key={label} className="px-4 py-3 text-left">
//                       <span className="flex items-center gap-1.5 text-xs font-semibold text-blue-500 uppercase tracking-widest whitespace-nowrap">
//                         {Icon && <Icon className="w-3.5 h-3.5" />}
//                         {label}
//                       </span>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td
//                       colSpan={tableHeaders.length}
//                       className="py-20 text-center"
//                     >
//                       <div className="flex flex-col items-center gap-3 text-blue-400">
//                         <AiOutlineLoading3Quarters className="w-7 h-7 animate-spin text-blue-500" />
//                         <span className="text-sm">Loading products…</span>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : filtered.length === 0 ? (
//                   <tr>
//                     <td
//                       colSpan={tableHeaders.length}
//                       className="py-20 text-center"
//                     >
//                       <div className="flex flex-col items-center gap-3">
//                         <div className="w-14 h-14 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center">
//                           <RiShoppingBag2Line className="w-7 h-7 text-blue-300" />
//                         </div>
//                         <span className="text-sm text-slate-400">
//                           {search
//                             ? "No products match your search."
//                             : "No products found. Add one to get started."}
//                         </span>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : (
//                   filtered.map((product, i) => (
//                     <tr
//                       key={product._id || i}
//                       className="border-b border-blue-50 hover:bg-blue-50/50 transition group"
//                     >
//                       <td className="px-4 py-3 font-semibold text-slate-800 whitespace-nowrap">
//                         {product.name || "—"}
//                       </td>
//                       <td className="px-4 py-3 text-slate-600 whitespace-nowrap">
//                         <span className="inline-flex items-center gap-1.5 px-2 py-1 bg-blue-50/80 border border-blue-200 rounded-md text-xs font-mono font-semibold text-blue-700">
//                           <RiBarcodeLine className="w-3 h-3" />
//                           {product.hsnCode || "N/A"}
//                         </span>
//                       </td>
//                       <td className="px-4 py-3 text-slate-600 whitespace-nowrap">
//                         {product.categoryId?.name || "—"}
//                       </td>
//                       <td className="px-4 py-3 text-slate-500 max-w-[200px] truncate">
//                         {product.description || "—"}
//                       </td>
//                       <td className="px-4 py-3">
//                         <div className="flex flex-col gap-1.5">
//                           {product.variations?.map((variation, idx) => (
//                             <div
//                               key={idx}
//                               className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-50 border border-blue-200 rounded-lg text-xs"
//                             >
//                               <span className="font-semibold text-blue-700">
//                                 {variation.size || "N/A"}
//                               </span>
//                               <span className="text-slate-400">|</span>
//                               <span className="text-emerald-600 font-medium">
//                                 ₹{variation.price || 0}
//                               </span>
//                               <span className="text-slate-400">|</span>
//                               <span className="text-blue-600">
//                                 Qty: {variation.quantity || 0}
//                               </span>
//                               {/* ── Add Stock button ── */}
//                               <button
//                                 onClick={() =>
//                                   openStockModal(product, variation)
//                                 }
//                                 title={`Add stock for size ${variation.size}`}
//                                 className="ml-1 flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100 border border-emerald-300 text-emerald-600 hover:bg-emerald-200 hover:text-emerald-700 transition"
//                               >
//                                 <RiAddLine className="w-3 h-3" />
//                               </button>
//                             </div>
//                           ))}
//                           {(!product.variations ||
//                             product.variations.length === 0) && (
//                             <div className="text-xs text-slate-400">
//                               No variations
//                             </div>
//                           )}
//                         </div>
//                       </td>
//                       <td className="px-4 py-3">
//                         <div className="flex gap-2 transition">
//                           <button
//                             onClick={() => openEdit(product)}
//                             className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
//                           >
//                             <RiEditLine className="w-3.5 h-3.5" /> Edit
//                           </button>
//                           <button
//                             onClick={() => openDelete(product)}
//                             className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-red-50 border border-red-200 text-red-500 hover:bg-red-100 font-semibold transition"
//                           >
//                             <RiDeleteBinLine className="w-3.5 h-3.5" /> Delete
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* ── Create Modal ── */}
//       {modal === "create" && (
//         <Modal
//           title={
//             <>
//               <RiAddLine className="w-5 h-5 text-blue-500" /> Add New Product
//             </>
//           }
//           onClose={closeModal}
//           size="lg"
//         >
//           <FormBody
//             form={form}
//             handleChange={handleChange}
//             handleVariationChange={handleVariationChange}
//             handleAddVariation={handleAddVariation}
//             handleRemoveVariation={handleRemoveVariation}
//             categories={categories}
//           />
//           <div className="flex justify-end gap-3 pt-2 border-t border-blue-50">
//             <button
//               onClick={closeModal}
//               className="flex items-center gap-1.5 px-5 py-2 rounded-lg text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
//             >
//               <RiCloseLine className="w-4 h-4" /> Cancel
//             </button>
//             <button
//               onClick={handleCreate}
//               disabled={actionLoading}
//               className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition shadow-md shadow-blue-200 disabled:opacity-60"
//             >
//               {actionLoading ? (
//                 <Spinner />
//               ) : (
//                 <RiCheckLine className="w-4 h-4" />
//               )}{" "}
//               Create Product
//             </button>
//           </div>
//         </Modal>
//       )}

//       {/* ── Edit Modal ── */}
//       {modal === "edit" && (
//         <Modal
//           title={
//             <>
//               <RiEditLine className="w-5 h-5 text-blue-500" /> Edit —{" "}
//               {selected?.name}
//             </>
//           }
//           onClose={closeModal}
//           size="lg"
//         >
//           <FormBody
//             form={form}
//             handleChange={handleChange}
//             handleVariationChange={handleVariationChange}
//             handleAddVariation={handleAddVariation}
//             handleRemoveVariation={handleRemoveVariation}
//             categories={categories}
//           />
//           <div className="flex justify-end gap-3 pt-2 border-t border-blue-50">
//             <button
//               onClick={closeModal}
//               className="flex items-center gap-1.5 px-5 py-2 rounded-lg text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
//             >
//               <RiCloseLine className="w-4 h-4" /> Cancel
//             </button>
//             <button
//               onClick={handleUpdate}
//               disabled={actionLoading}
//               className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition shadow-md shadow-blue-200 disabled:opacity-60"
//             >
//               {actionLoading ? (
//                 <Spinner />
//               ) : (
//                 <RiCheckLine className="w-4 h-4" />
//               )}{" "}
//               Save Changes
//             </button>
//           </div>
//         </Modal>
//       )}

//       {/* ── Delete Modal ── */}
//       {modal === "delete" && (
//         <Modal
//           title={
//             <>
//               <RiDeleteBinLine className="w-5 h-5 text-red-500" /> Confirm
//               Deletion
//             </>
//           }
//           onClose={closeModal}
//         >
//           <div className="text-center py-4">
//             <div className="w-16 h-16 rounded-full bg-red-50 border border-red-100 flex items-center justify-center mx-auto mb-4">
//               <RiErrorWarningLine className="w-8 h-8 text-red-500" />
//             </div>
//             <p className="text-slate-700 font-semibold mb-1 text-base">
//               Delete <span className="text-red-500">{selected?.name}</span>?
//             </p>
//             <p className="text-slate-400 text-sm mb-6">
//               This action cannot be undone. The product and all its variations
//               will be permanently removed.
//             </p>
//             <div className="flex justify-center gap-3">
//               <button
//                 onClick={closeModal}
//                 className="flex items-center gap-1.5 px-6 py-2 rounded-lg text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition"
//               >
//                 <RiCloseLine className="w-4 h-4" /> Cancel
//               </button>
//               <button
//                 onClick={handleDelete}
//                 disabled={actionLoading}
//                 className="flex items-center gap-2 px-6 py-2 rounded-lg text-sm font-semibold bg-red-500 hover:bg-red-600 text-white transition shadow-md shadow-red-100 disabled:opacity-60"
//               >
//                 {actionLoading ? (
//                   <Spinner />
//                 ) : (
//                   <RiDeleteBinLine className="w-4 h-4" />
//                 )}{" "}
//                 Delete Product
//               </button>
//             </div>
//           </div>
//         </Modal>
//       )}

//       {/* ── Add Stock Modal ── */}
//       {stockModal && (
//         <Modal
//           title={
//             <>
//               <RiAddCircleLine className="w-5 h-5 text-emerald-500" /> Add Stock
//             </>
//           }
//           onClose={closeStockModal}
//           size="sm"
//         >
//           {/* Info row */}
//           <div className="flex items-center gap-3 mb-5 p-3 bg-blue-50/60 border border-blue-100 rounded-xl">
//             <div className="flex flex-col">
//               <span className="text-xs text-blue-400 uppercase tracking-widest font-semibold mb-0.5">
//                 Product
//               </span>
//               <span className="text-sm font-semibold text-slate-800">
//                 {stockModal.product.name}
//               </span>
//             </div>
//             <div className="w-px h-8 bg-blue-200 mx-1" />
//             <div className="flex flex-col">
//               <span className="text-xs text-blue-400 uppercase tracking-widest font-semibold mb-0.5">
//                 Size
//               </span>
//               <span className="text-sm font-semibold text-blue-700">
//                 {stockModal.variation.size}
//               </span>
//             </div>
//             <div className="w-px h-8 bg-blue-200 mx-1" />
//             <div className="flex flex-col">
//               <span className="text-xs text-blue-400 uppercase tracking-widest font-semibold mb-0.5">
//                 Current Qty
//               </span>
//               <span className="text-sm font-semibold text-slate-700">
//                 {stockModal.variation.quantity || 0}
//               </span>
//             </div>
//           </div>

//           {/* Input */}
//           <div className="flex flex-col gap-1.5 mb-5">
//             <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//               Quantity to Add
//             </label>
//             <input
//               type="number"
//               min="1"
//               placeholder="e.g. 50"
//               value={stockQty}
//               onChange={(e) => setStockQty(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && handleAddStock()}
//               autoFocus
//               className="w-full bg-blue-50/60 border border-blue-200 rounded-lg px-4 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-emerald-400 focus:ring-2 focus:ring-emerald-400/20 transition"
//             />
//             {stockQty && parseInt(stockQty) > 0 && (
//               <p className="text-xs text-emerald-600 font-medium">
//                 New total will be{" "}
//                 <span className="font-bold">
//                   {(stockModal.variation.quantity || 0) + parseInt(stockQty)}
//                 </span>{" "}
//                 units
//               </p>
//             )}
//           </div>

//           {/* Actions */}
//           <div className="flex gap-3">
//             <button
//               onClick={closeStockModal}
//               className="flex-1 flex items-center justify-center gap-1.5 px-4 py-2 rounded-lg text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition"
//             >
//               <RiCloseLine className="w-4 h-4" /> Cancel
//             </button>
//             <button
//               onClick={handleAddStock}
//               disabled={stockLoading || !stockQty || parseInt(stockQty) <= 0}
//               className="flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold bg-emerald-500 hover:bg-emerald-600 text-white transition shadow-md shadow-emerald-100 disabled:opacity-60"
//             >
//               {stockLoading ? (
//                 <Spinner />
//               ) : (
//                 <RiAddCircleLine className="w-4 h-4" />
//               )}{" "}
//               Add Stock
//             </button>
//           </div>
//         </Modal>
//       )}

//       {toast && <Toast {...toast} onClose={() => setToast(null)} />}
//     </div>
//   );
// }

import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import {
  RiShoppingBag2Line,
  RiAddLine,
  RiSearchLine,
  RiCloseLine,
  RiEditLine,
  RiDeleteBinLine,
  RiCheckLine,
  RiErrorWarningLine,
  RiRefreshLine,
  RiFileTextLine,
  RiGiftLine,
  RiStackLine,
  RiOctagonLine,
  RiAddCircleLine,
  RiBarcodeLine,
  RiMoneyDollarCircleLine, // Replaced RiDiscountLine
  RiLayoutGridLine, // Replaced RiLayersLine
} from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const BASE_URL = `${process.env.REACT_APP_API_URL}/product`;
const CATEGORY_URL = `${process.env.REACT_APP_API_URL}/category`;

const defaultForm = {
  name: "",
  description: "",
  categoryId: "",
  type: "withoutVariation",
  price: "", // Only for withoutVariation
  hsnCode: "",
  variations: [],
};

const defaultVariation = {
  size: "",
  price: "",
  quantity: "",
};

const Spinner = () => (
  <AiOutlineLoading3Quarters className="animate-spin w-4 h-4" />
);

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, []);
  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
      ${
        type === "success"
          ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
          : "bg-red-50 border border-red-200 text-red-800"
      }`}
    >
      {type === "success" ? (
        <RiCheckLine className="w-4 h-4 text-emerald-500" />
      ) : (
        <RiErrorWarningLine className="w-4 h-4 text-red-500" />
      )}
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-2 opacity-50 hover:opacity-100 transition"
      >
        <RiCloseLine className="w-4 h-4" />
      </button>
    </div>
  );
};

const Modal = ({ title, onClose, children, size = "md" }) =>
  createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-blue-950/40 backdrop-blur-sm"
        onClick={onClose}
      />
      <div
        className={`relative z-10 w-full ${
          size === "lg" ? "max-w-4xl" : size === "sm" ? "max-w-sm" : "max-w-2xl"
        } mx-4 bg-white border border-blue-100 rounded-2xl shadow-2xl overflow-hidden`}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-blue-50">
          <h2 className="text-base font-semibold text-blue-900 flex items-center gap-2">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="text-blue-400 hover:text-blue-700 transition rounded-lg p-1 hover:bg-blue-100"
          >
            <RiCloseLine className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 max-h-[80vh] overflow-y-auto bg-white">
          {children}
        </div>
      </div>
    </div>,
    document.body,
  );

const fieldIconMap = {
  name: RiOctagonLine,
  description: RiFileTextLine,
  categoryId: RiStackLine,
  hsnCode: RiBarcodeLine,
  type: RiLayoutGridLine, // Updated
  price: RiMoneyDollarCircleLine, // Updated
};

const Field = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder,
  as = "input",
  options = [],
  disabled = false,
}) => {
  const Icon = fieldIconMap[name] || RiFileTextLine;
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
        {label}
      </label>
      <div className="relative">
        <Icon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
        {as === "textarea" ? (
          <textarea
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder || label}
            rows={3}
            className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition resize-none"
          />
        ) : as === "select" ? (
          <select
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {options.map((opt) => (
              <option key={opt._id || opt.value} value={opt.value || opt._id}>
                {opt.name || opt.label}
              </option>
            ))}
          </select>
        ) : (
          <input
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder || label}
            disabled={disabled}
            className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition disabled:opacity-50 disabled:cursor-not-allowed"
          />
        )}
      </div>
    </div>
  );
};

const VariationField = ({ variation, onChange, onRemove, index }) => {
  return (
    <div className="bg-blue-50/30 border border-blue-100 rounded-lg p-4 mb-3">
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-sm font-semibold text-slate-700">
          Variation {index + 1}
        </h4>
        {onRemove && (
          <button
            type="button"
            onClick={onRemove}
            className="text-red-500 hover:text-red-700 transition"
          >
            <RiDeleteBinLine className="w-4 h-4" />
          </button>
        )}
      </div>
      <div className="grid grid-cols-3 gap-3">
        <input
          type="text"
          placeholder="Size (S, M, L, XL)"
          value={variation.size || ""}
          onChange={(e) => onChange({ ...variation, size: e.target.value })}
          className="bg-white border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
        />
        <input
          type="number"
          placeholder="Price"
          value={variation.price || ""}
          onChange={(e) =>
            onChange({ ...variation, price: parseFloat(e.target.value) || "" })
          }
          className="bg-white border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
        />
        <input
          type="number"
          placeholder="Quantity"
          value={variation.quantity || ""}
          onChange={(e) =>
            onChange({ ...variation, quantity: parseInt(e.target.value) || "" })
          }
          className="bg-white border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
        />
      </div>
    </div>
  );
};

const FormBody = ({
  form,
  handleChange,
  handleVariationChange,
  handleAddVariation,
  handleRemoveVariation,
  categories,
}) => {
  const productTypeOptions = [
    { value: "withoutVariation", label: "Simple Product (No Variations)" },
    { value: "withVariation", label: "Product with Variations (Sizes)" },
  ];

  return (
    <>
      <div className="grid grid-cols-2 gap-4 mb-4">
        <Field
          label="Product Name"
          name="name"
          value={form.name}
          onChange={handleChange}
        />
        <Field
          label="Category"
          name="categoryId"
          value={form.categoryId}
          onChange={handleChange}
          as="select"
          options={[{ _id: "", name: "Select a category" }, ...categories]}
        />
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <Field
          label="Product Type"
          name="type"
          value={form.type}
          onChange={handleChange}
          as="select"
          options={productTypeOptions}
        />
        <Field
          label="HSN Code"
          name="hsnCode"
          value={form.hsnCode}
          onChange={handleChange}
          placeholder="e.g., 84716000"
        />
      </div>

      {/* Simple Product Fields (without variation) - Only Price field */}
      {form.type === "withoutVariation" && (
        <div className="mb-6 p-4 bg-emerald-50/30 border border-emerald-100 rounded-lg">
          <Field
            label="Price (₹)"
            name="price"
            type="number"
            value={form.price}
            onChange={handleChange}
            placeholder="Enter price"
          />
        </div>
      )}

      <div className="mb-4">
        <Field
          label="Description"
          name="description"
          value={form.description}
          onChange={handleChange}
          as="textarea"
        />
      </div>

      {/* Variations Section (only for withVariation type) */}
      {form.type === "withVariation" && (
        <div className="mb-6">
          <div className="flex items-center justify-between mb-3">
            <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
              Variations (Sizes)
            </label>
            <button
              type="button"
              onClick={handleAddVariation}
              className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
            >
              <RiAddLine className="w-3.5 h-3.5" /> Add Variation
            </button>
          </div>

          {form.variations && form.variations.length > 0 ? (
            form.variations.map((variation, idx) => (
              <VariationField
                key={idx}
                index={idx}
                variation={variation}
                onChange={(v) => handleVariationChange(idx, v)}
                onRemove={() => handleRemoveVariation(idx)}
              />
            ))
          ) : (
            <div className="text-center py-8 bg-blue-50/30 border border-dashed border-blue-200 rounded-lg">
              <RiGiftLine className="w-8 h-8 text-blue-300 mx-auto mb-2" />
              <p className="text-sm text-slate-400">
                No variations added. Click "Add Variation" to get started.
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
};

const tableHeaders = [
  { label: "Product Name", Icon: RiOctagonLine },
  { label: "Type", Icon: RiLayoutGridLine }, // Updated
  { label: "HSN Code", Icon: RiBarcodeLine },
  { label: "Category", Icon: RiStackLine },
  { label: "Price/Stock", Icon: RiMoneyDollarCircleLine }, // Updated
  { label: "Actions" },
];

export default function Products() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [modal, setModal] = useState(null);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState(defaultForm);
  const [toast, setToast] = useState(null);
  const [search, setSearch] = useState("");

  // Stock modal state (only for variations)
  const [stockModal, setStockModal] = useState(null);
  const [stockQty, setStockQty] = useState("");
  const [stockLoading, setStockLoading] = useState(false);

  const notify = (message, type = "success") => setToast({ message, type });

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${CATEGORY_URL}/all`);
      setCategories(res.data?.categories || res.data?.data || res.data || []);
    } catch (error) {
      console.error("Failed to fetch categories:", error);
    }
  };

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/all`);
      setProducts(res.data?.products || res.data?.data || res.data || []);
    } catch {
      notify("Failed to fetch products", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, []);

  const openCreate = () => {
    setForm({
      ...defaultForm,
      type: "withoutVariation",
      variations: [],
    });
    setModal("create");
  };

  const openEdit = (product) => {
    setSelected(product);
    setForm({
      name: product.name || "",
      description: product.description || "",
      categoryId: product.categoryId?._id || product.categoryId || "",
      type: product.type || "withoutVariation",
      price: product.price || "",
      hsnCode: product.hsnCode || "",
      variations: product.variations || [],
    });
    setModal("edit");
  };

  const openDelete = (product) => {
    setSelected(product);
    setModal("delete");
  };

  const closeModal = () => {
    setModal(null);
    setSelected(null);
  };

  const openStockModal = (product, variation) => {
    setStockModal({ product, variation });
    setStockQty("");
  };

  const closeStockModal = () => {
    setStockModal(null);
    setStockQty("");
  };

  const handleAddStock = async () => {
    const addQty = parseInt(stockQty);
    if (!addQty || addQty <= 0) {
      notify("Please enter a valid quantity", "error");
      return;
    }

    setStockLoading(true);
    try {
      const newQty = (stockModal.variation.quantity || 0) + addQty;
      await axios.patch(`${BASE_URL}/update-stock`, {
        productId: stockModal.product._id,
        size: stockModal.variation.size,
        quantity: newQty,
      });
      notify(
        `Added ${addQty} units to ${stockModal.product.name} (${stockModal.variation.size})`,
      );
      fetchProducts();
      closeStockModal();
    } catch (error) {
      notify(
        error.response?.data?.message || "Failed to update stock",
        "error",
      );
      console.error("Stock update error:", error);
    } finally {
      setStockLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Reset variation-related fields when switching type
    if (name === "type") {
      if (value === "withoutVariation") {
        setForm((f) => ({
          ...f,
          type: value,
          variations: [],
          price: "",
        }));
      } else {
        setForm((f) => ({
          ...f,
          type: value,
          price: "",
          variations: [{ ...defaultVariation }],
        }));
      }
    } else {
      setForm((f) => ({ ...f, [name]: value }));
    }
  };

  const handleVariationChange = (index, variation) => {
    setForm((f) => {
      const newVariations = [...f.variations];
      newVariations[index] = variation;
      return { ...f, variations: newVariations };
    });
  };

  const handleAddVariation = () => {
    setForm((f) => ({
      ...f,
      variations: [...f.variations, { ...defaultVariation }],
    }));
  };

  const handleRemoveVariation = (index) => {
    setForm((f) => ({
      ...f,
      variations: f.variations.filter((_, i) => i !== index),
    }));
  };

  const validateForm = () => {
    if (!form.name.trim()) {
      notify("Product name is required", "error");
      return false;
    }
    if (!form.categoryId) {
      notify("Please select a category", "error");
      return false;
    }
    if (form.type === "withoutVariation") {
      if (!form.price || form.price <= 0) {
        notify("Please enter a valid price", "error");
        return false;
      }
    } else if (form.type === "withVariation") {
      if (!form.variations || form.variations.length === 0) {
        notify("Please add at least one variation", "error");
        return false;
      }
      for (let i = 0; i < form.variations.length; i++) {
        const v = form.variations[i];
        if (!v.size.trim()) {
          notify(`Variation ${i + 1}: Size is required`, "error");
          return false;
        }
        if (!v.price || v.price <= 0) {
          notify(`Variation ${i + 1}: Valid price is required`, "error");
          return false;
        }
        if (!v.quantity || v.quantity < 0) {
          notify(`Variation ${i + 1}: Valid quantity is required`, "error");
          return false;
        }
      }
    }
    if (form.hsnCode && !/^\d{4,8}$/.test(form.hsnCode)) {
      notify("HSN code must be 4 to 8 digits", "error");
      return false;
    }
    return true;
  };

  const handleCreate = async () => {
    if (!validateForm()) return;

    setActionLoading(true);
    try {
      const payload = { ...form };
      if (payload.type === "withoutVariation") {
        delete payload.variations;
      } else {
        delete payload.price;
      }
      await axios.post(`${BASE_URL}/create`, payload);
      notify("Product created successfully");
      fetchProducts();
      closeModal();
    } catch (error) {
      notify(
        error.response?.data?.message || "Failed to create product",
        "error",
      );
      console.error("Create error:", error);
    } finally {
      setActionLoading(false);
    }
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;

    setActionLoading(true);
    try {
      const payload = { ...form };
      if (payload.type === "withoutVariation") {
        delete payload.variations;
      } else {
        delete payload.price;
      }
      await axios.put(`${BASE_URL}/update/${selected._id}`, payload);
      notify("Product updated successfully");
      fetchProducts();
      closeModal();
    } catch (error) {
      notify(
        error.response?.data?.message || "Failed to update product",
        "error",
      );
      console.error("Update error:", error);
    } finally {
      setActionLoading(false);
    }
  };

  const handleDelete = async () => {
    setActionLoading(true);
    try {
      await axios.delete(`${BASE_URL}/delete/${selected._id}`);
      notify("Product deleted successfully");
      fetchProducts();
      closeModal();
    } catch (error) {
      notify("Failed to delete product", "error");
      console.error("Delete error:", error);
    } finally {
      setActionLoading(false);
    }
  };

  const filtered = products.filter(
    (p) =>
      (p.name || "").toLowerCase().includes(search.toLowerCase()) ||
      (p.description || "").toLowerCase().includes(search.toLowerCase()) ||
      (p.hsnCode || "").toLowerCase().includes(search.toLowerCase()),
  );

  const renderProductDetails = (product) => {
    if (product.type === "withoutVariation") {
      return (
        <div className="flex flex-col gap-1">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-emerald-50 border border-emerald-200 rounded-lg text-xs">
            <span className="font-semibold text-emerald-700">Price:</span>
            <span className="text-emerald-600 font-medium">
              ₹{product.price || 0}
            </span>
          </div>
        </div>
      );
    } else {
      return (
        <div className="flex flex-col gap-1.5">
          {product.variations?.map((variation, idx) => (
            <div
              key={idx}
              className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-50 border border-blue-200 rounded-lg text-xs"
            >
              <span className="font-semibold text-blue-700">
                {variation.size || "N/A"}
              </span>
              <span className="text-slate-400">|</span>
              <span className="text-emerald-600 font-medium">
                ₹{variation.price || 0}
              </span>
              <span className="text-slate-400">|</span>
              <span className="text-blue-600">
                Qty: {variation.quantity || 0}
              </span>
              <button
                onClick={() => openStockModal(product, variation)}
                title={`Add stock for size ${variation.size}`}
                className="ml-1 flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100 border border-emerald-300 text-emerald-600 hover:bg-emerald-200 hover:text-emerald-700 transition"
              >
                <RiAddLine className="w-3 h-3" />
              </button>
            </div>
          ))}
          {(!product.variations || product.variations.length === 0) && (
            <div className="text-xs text-slate-400">No variations</div>
          )}
        </div>
      );
    }
  };

  return (
    <div className="min-h-screen bg-white text-slate-800">
      <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
        <div className="w-full mx-auto px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-md shadow-blue-200">
              <RiShoppingBag2Line className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-bold text-blue-800 tracking-tight">
                Products
              </h1>
              <p className="text-[11px] text-blue-400 tracking-widest uppercase">
                Product Management
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="relative">
              <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400" />
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search products..."
                className="bg-blue-50 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-700 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 w-52 transition"
              />
            </div>

            <button
              onClick={fetchProducts}
              disabled={loading}
              title="Refresh"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-600 hover:bg-blue-50 transition disabled:opacity-50"
            >
              <RiRefreshLine
                className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
              />
            </button>

            <button
              onClick={openCreate}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm px-4 py-2 rounded-lg transition-all shadow-md shadow-blue-200"
            >
              <RiAddLine className="w-4 h-4" />
              Add Product
            </button>
          </div>
        </div>
      </header>

      <div className="w-full mx-auto px-6 pt-6 pb-10">
        <div className="bg-white border border-blue-100 rounded-2xl overflow-hidden shadow-sm">
          <div className="px-5 py-3.5 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
            <span className="text-sm font-semibold text-blue-800 flex items-center gap-2">
              <RiShoppingBag2Line className="w-4 h-4 text-blue-500" />
              All Products
            </span>
            <span className="text-xs text-blue-400">
              {filtered.length} record{filtered.length !== 1 ? "s" : ""}
            </span>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-blue-100 bg-blue-50/30">
                  {tableHeaders.map(({ label, Icon }) => (
                    <th key={label} className="px-4 py-3 text-left">
                      <span className="flex items-center gap-1.5 text-xs font-semibold text-blue-500 uppercase tracking-widest whitespace-nowrap">
                        {Icon && <Icon className="w-3.5 h-3.5" />}
                        {label}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan={tableHeaders.length}
                      className="py-20 text-center"
                    >
                      <div className="flex flex-col items-center gap-3 text-blue-400">
                        <AiOutlineLoading3Quarters className="w-7 h-7 animate-spin text-blue-500" />
                        <span className="text-sm">Loading products…</span>
                      </div>
                    </td>
                  </tr>
                ) : filtered.length === 0 ? (
                  <tr>
                    <td
                      colSpan={tableHeaders.length}
                      className="py-20 text-center"
                    >
                      <div className="flex flex-col items-center gap-3">
                        <div className="w-14 h-14 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center">
                          <RiShoppingBag2Line className="w-7 h-7 text-blue-300" />
                        </div>
                        <span className="text-sm text-slate-400">
                          {search
                            ? "No products match your search."
                            : "No products found. Add one to get started."}
                        </span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filtered.map((product, i) => (
                    <tr
                      key={product._id || i}
                      className="border-b border-blue-50 hover:bg-blue-50/50 transition group"
                    >
                      <td className="px-4 py-3 font-semibold text-slate-800 whitespace-nowrap">
                        {product.name || "—"}
                      </td>
                      <td className="px-4 py-3">
                        <span
                          className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-xs font-semibold ${
                            product.type === "withoutVariation"
                              ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                              : "bg-blue-50 text-blue-700 border border-blue-200"
                          }`}
                        >
                          <RiLayoutGridLine className="w-3 h-3" />
                          {product.type === "withoutVariation"
                            ? "Simple"
                            : "With Variations"}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-slate-600 whitespace-nowrap">
                        <span className="inline-flex items-center gap-1.5 px-2 py-1 bg-blue-50/80 border border-blue-200 rounded-md text-xs font-mono font-semibold text-blue-700">
                          <RiBarcodeLine className="w-3 h-3" />
                          {product.hsnCode || "N/A"}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-slate-600 whitespace-nowrap">
                        {product.categoryId?.name || "—"}
                      </td>
                      <td className="px-4 py-3">
                        {renderProductDetails(product)}
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex gap-2 transition">
                          <button
                            onClick={() => openEdit(product)}
                            className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
                          >
                            <RiEditLine className="w-3.5 h-3.5" /> Edit
                          </button>
                          <button
                            onClick={() => openDelete(product)}
                            className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-red-50 border border-red-200 text-red-500 hover:bg-red-100 font-semibold transition"
                          >
                            <RiDeleteBinLine className="w-3.5 h-3.5" /> Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Create Modal */}
      {modal === "create" && (
        <Modal
          title={
            <>
              <RiAddLine className="w-5 h-5 text-blue-500" /> Add New Product
            </>
          }
          onClose={closeModal}
          size="lg"
        >
          <FormBody
            form={form}
            handleChange={handleChange}
            handleVariationChange={handleVariationChange}
            handleAddVariation={handleAddVariation}
            handleRemoveVariation={handleRemoveVariation}
            categories={categories}
          />
          <div className="flex justify-end gap-3 pt-2 border-t border-blue-50">
            <button
              onClick={closeModal}
              className="flex items-center gap-1.5 px-5 py-2 rounded-lg text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
            >
              <RiCloseLine className="w-4 h-4" /> Cancel
            </button>
            <button
              onClick={handleCreate}
              disabled={actionLoading}
              className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition shadow-md shadow-blue-200 disabled:opacity-60"
            >
              {actionLoading ? (
                <Spinner />
              ) : (
                <RiCheckLine className="w-4 h-4" />
              )}{" "}
              Create Product
            </button>
          </div>
        </Modal>
      )}

      {/* Edit Modal */}
      {modal === "edit" && (
        <Modal
          title={
            <>
              <RiEditLine className="w-5 h-5 text-blue-500" /> Edit —{" "}
              {selected?.name}
            </>
          }
          onClose={closeModal}
          size="lg"
        >
          <FormBody
            form={form}
            handleChange={handleChange}
            handleVariationChange={handleVariationChange}
            handleAddVariation={handleAddVariation}
            handleRemoveVariation={handleRemoveVariation}
            categories={categories}
          />
          <div className="flex justify-end gap-3 pt-2 border-t border-blue-50">
            <button
              onClick={closeModal}
              className="flex items-center gap-1.5 px-5 py-2 rounded-lg text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
            >
              <RiCloseLine className="w-4 h-4" /> Cancel
            </button>
            <button
              onClick={handleUpdate}
              disabled={actionLoading}
              className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition shadow-md shadow-blue-200 disabled:opacity-60"
            >
              {actionLoading ? (
                <Spinner />
              ) : (
                <RiCheckLine className="w-4 h-4" />
              )}{" "}
              Save Changes
            </button>
          </div>
        </Modal>
      )}

      {/* Delete Modal */}
      {modal === "delete" && (
        <Modal
          title={
            <>
              <RiDeleteBinLine className="w-5 h-5 text-red-500" /> Confirm
              Deletion
            </>
          }
          onClose={closeModal}
        >
          <div className="text-center py-4">
            <div className="w-16 h-16 rounded-full bg-red-50 border border-red-100 flex items-center justify-center mx-auto mb-4">
              <RiErrorWarningLine className="w-8 h-8 text-red-500" />
            </div>
            <p className="text-slate-700 font-semibold mb-1 text-base">
              Delete <span className="text-red-500">{selected?.name}</span>?
            </p>
            <p className="text-slate-400 text-sm mb-6">
              This action cannot be undone. The product will be permanently
              removed.
            </p>
            <div className="flex justify-center gap-3">
              <button
                onClick={closeModal}
                className="flex items-center gap-1.5 px-6 py-2 rounded-lg text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition"
              >
                <RiCloseLine className="w-4 h-4" /> Cancel
              </button>
              <button
                onClick={handleDelete}
                disabled={actionLoading}
                className="flex items-center gap-2 px-6 py-2 rounded-lg text-sm font-semibold bg-red-500 hover:bg-red-600 text-white transition shadow-md shadow-red-100 disabled:opacity-60"
              >
                {actionLoading ? (
                  <Spinner />
                ) : (
                  <RiDeleteBinLine className="w-4 h-4" />
                )}{" "}
                Delete Product
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Add Stock Modal - Only for variations */}
      {stockModal && (
        <Modal
          title={
            <>
              <RiAddCircleLine className="w-5 h-5 text-emerald-500" /> Add Stock
            </>
          }
          onClose={closeStockModal}
          size="sm"
        >
          <div className="flex items-center gap-3 mb-5 p-3 bg-blue-50/60 border border-blue-100 rounded-xl">
            <div className="flex flex-col">
              <span className="text-xs text-blue-400 uppercase tracking-widest font-semibold mb-0.5">
                Product
              </span>
              <span className="text-sm font-semibold text-slate-800">
                {stockModal.product.name}
              </span>
            </div>
            <div className="w-px h-8 bg-blue-200 mx-1" />
            <div className="flex flex-col">
              <span className="text-xs text-blue-400 uppercase tracking-widest font-semibold mb-0.5">
                Size
              </span>
              <span className="text-sm font-semibold text-blue-700">
                {stockModal.variation.size}
              </span>
            </div>
            <div className="w-px h-8 bg-blue-200 mx-1" />
            <div className="flex flex-col">
              <span className="text-xs text-blue-400 uppercase tracking-widest font-semibold mb-0.5">
                Current Qty
              </span>
              <span className="text-sm font-semibold text-slate-700">
                {stockModal.variation.quantity || 0}
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-1.5 mb-5">
            <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
              Quantity to Add
            </label>
            <input
              type="number"
              min="1"
              placeholder="e.g. 50"
              value={stockQty}
              onChange={(e) => setStockQty(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleAddStock()}
              autoFocus
              className="w-full bg-blue-50/60 border border-blue-200 rounded-lg px-4 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-emerald-400 focus:ring-2 focus:ring-emerald-400/20 transition"
            />
            {stockQty && parseInt(stockQty) > 0 && (
              <p className="text-xs text-emerald-600 font-medium">
                New total will be{" "}
                <span className="font-bold">
                  {(stockModal.variation.quantity || 0) + parseInt(stockQty)}
                </span>{" "}
                units
              </p>
            )}
          </div>

          <div className="flex gap-3">
            <button
              onClick={closeStockModal}
              className="flex-1 flex items-center justify-center gap-1.5 px-4 py-2 rounded-lg text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition"
            >
              <RiCloseLine className="w-4 h-4" /> Cancel
            </button>
            <button
              onClick={handleAddStock}
              disabled={stockLoading || !stockQty || parseInt(stockQty) <= 0}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold bg-emerald-500 hover:bg-emerald-600 text-white transition shadow-md shadow-emerald-100 disabled:opacity-60"
            >
              {stockLoading ? (
                <Spinner />
              ) : (
                <RiAddCircleLine className="w-4 h-4" />
              )}{" "}
              Add Stock
            </button>
          </div>
        </Modal>
      )}

      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
}
